// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"a777d4b2","561":"0b9e2321"}[chunkId] + ".chunk.css";
};